import React, { useEffect, useState } from "react";
// import { useFormik } from "formik";
import Swal from "sweetalert2";
import * as Yup from "yup";
import {
  Container,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
} from "reactstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import { format } from "date-fns";
import { Loading } from "../../share/loading";
import { Formik, Field, FieldArray, Form } from "formik";
import "../../share/form.css";
import { FaSistrix } from "react-icons/fa";


export function ExtendBorrowCheckComponent() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("userData"));
  // console.log(user);
  let borrowId = searchParams.get("req");
  let trainTestId = searchParams.get("trainTestId");
  const [loading, setLoading] = useState(false);
  const [openModalForm, setOpenModalForm] = useState(false);
  const modalToggleExtendCourse = () => setOpenModalForm(!openModalForm);
  const [remarkPromotionValue, setRemarkPromotionValue] = useState("");
  const [data, setData] = useState([]);
  const [testdata, settestData] = useState([]);
  // const [databorrowDetails, setborrowDetailsData] = useState([]);
  // const [dataclassDetails, setclassDetailsData] = useState([]);
  const [borrowDetailtestdata, setborrowDetailtestdata] = useState([]);

  useEffect(() => {
    gettraindata();
    getdetailsupport2();
    gettestdata();
  }, []);

  async function gettraindata() {
    setLoading(true);
    let postData = new FormData();
    postData.append("borrowId", borrowId);
    postData.append("trainTestId", trainTestId);
    try {
      let res = await fetch("/api/Borrow/getTrainDetail", {
        method: "POST",
        body: postData,
      });
      const data = await res.json();
      // console.log(data.dataenum);
      setData(data.dataenum);
    } catch (e) {
      // console.log("err =>" + e);
    } finally {
      setLoading(false);
    }
  }
  async function gettestdata() {
    setLoading(true);
    let postData = new FormData();
    postData.append("borrowId", borrowId);
    postData.append("traintestId", trainTestId);
    try {
      let res = await fetch("/api/Borrow/getTestDetail", {
        method: "POST",
        body: postData,
      });
      const data = await res.json();
      // console.log(data.dataenum);
      settestData(data.dataenum);


    } catch (e) {
      // console.log("err =>" + e);
    } finally {
      setLoading(false);
    }
  }

  async function getdetailsupport2() {
    setLoading(true);
    let postData = new FormData();
    postData.append("borrowId", searchParams.get("req"));
    try {
      let res = await fetch("/api/Borrow/getTestAllDetail", {
        method: "POST",
        body: postData,
      });

      // });
      const data = await res.json();
      setborrowDetailtestdata(data.dataenum.borrowDetailtestdata);
      // console.log("dataalldetail", data.dataenum);
    } catch (e) {
      // console.log("err =>" + e);
    } finally {
      setLoading(false);
    }
  }

  // console.log("trainNewClassId",borrowDetailtestdata?.trainNewClassId);

  const formPromotionInitialValues = {

    // RemarkOfficer: remarkPromotionValue,
    // TestNewStatus: remarkPromotionValue != "" ? "21" : "8",
    TrainNewStatus: data[0]?.trainNewClassId != null ? "17" : "13",
    TestNewStatus: borrowDetailtestdata?.testNewClassId ? "17" : "13",
    trainNewClassId: data[0]?.trainNewClassId,
    testNewClassId: borrowDetailtestdata?.testNewClassId,
    borrowId: searchParams.get("req"),
    trainTestId: trainTestId
  };


  const formRejectInitialValues = {
    RemarkOfficer: "",
    TrainNewStatus: data[0]?.trainNewClassId != null ? "13" : "13",
    TrainNewStatus: remarkPromotionValue != "" ? "13" : "17",
    TestNewStatus: borrowDetailtestdata?.testNewClassId ? "13" : "13",
    // TestNewStatus: remarkPromotionValue != "" ? "13" : "17",
    trainNewClassId: data[0]?.trainNewClassId,
    testNewClassId: borrowDetailtestdata?.testNewClassId,
    borrowId: searchParams.get("req"),
    trainTestId: trainTestId
  };



  const validatePromotionSchema = Yup.object().shape({});
  const validateRejectSchema = Yup.object().shape({});

  const promotionSubmit = async (values, setFieldValue) => {
    // console.log(values)
    try {
      let res = await fetch("api/Borrow/approveOrRejectChange", {
        method: "POST",
        headers: { "Content-type": "application/json" },
        body: JSON.stringify(values),
      });
      // console.log("values5", values);
      let resJson = await res.json();

      if (resJson.status === 1) {
        Swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลสำเร็จ",
          confirmButtonColor: "#0A66C2",
          confirmButtonText: "ตกลง",
        }).then((result) => {
          navigate(`/borrowing/`);
        });
      }
    } catch (e) {
      // console.log(e);
    }
  };

  const RejectSubmit = async (values, setFieldValue) => {
    // console.log(values);

    try {
      let res = await fetch("api/Borrow/approveOrRejectChangeTest", {
        method: "POST",
        headers: { "Content-type": "application/json" },
        body: JSON.stringify(values),
      });
      // console.log("values5", values);
      let resJson = await res.json();

      if (resJson.status === 1) {
        Swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลสำเร็จ",
          confirmButtonColor: "#0A66C2",
          confirmButtonText: "ตกลง",
        }).then((result) => {
          navigate(`/borrowing/`);
        });
      }
    } catch (e) {
      // console.log(e);
    }
  };

  return (
    <Formik
      initialValues={formPromotionInitialValues}
      validationSchema={validatePromotionSchema}
      onSubmit={promotionSubmit}
      enableReinitialize
    >
      {({
        values,
        handleChange,
        handleBlur,
        setFieldTouched,
        errors,
        handleSubmit,
        setFieldValue,
      }) => {
        function rejectButtonPromotionClick() {
          Swal.fire({
            title: "",
            text: "กรุณากรอกความคิดเห็น",
            confirmButtonColor: "#0A66C2",
            confirmButtonText: "ตกลง",
            input: "text",
            inputValue: remarkPromotionValue,
            showCancelButton: true,
            cancelButtonText: "ยกเลิก",
            cancelButtonColor: "#ff0000",
            inputValidator: (value) => {
              if (!value) {
                return "กรุณากรอกความคิดเห็น";
              }
            },
          }).then((result) => {
            if (result.value) {
              // console.log("value1", result.value);
              setRemarkPromotionValue(result.value);
              // setFieldValue("TrainNewStatus", "21");
              promotionSubmit(values);
            }
          });
        }
        return (
          <>
            <Form onSubmit={handleSubmit}>
              <Container className="d-flex flex-column justify-content-center align-items-center">
                <p
                  className="text-center py-2 text-white"
                  style={{
                    backgroundColor: "#0A66C2",
                    width: "100%",
                    maxWidth: "850px",
                  }}
                >
                  ข้อมูลคำขอเลื่อนฝึกอบรมหรือทดสอบ
                </p>
                {/* รายละเอียดย่อย */}
                <div className="form-border">
                  {data[0]?.trainNewClassId != null ? (
                    <>
                      <div className="d-flex flex-column">
                        <div className="px-5 mt-5 d-flex flex-column">
                          <div className="d-flex justify-content-between align-items-center w-100">
                            <span className="py-1 mx-1 type-register">
                              เลขที่สัญญา
                            </span>
                            <span className="mx-2 input-color border border-1 rounded-pill px-5 py-1 w-75 text-center">
                              {data[0]?.contactNo
                                ? data[0]?.contactNo
                                : "-"}
                            </span>
                          </div>
                          <div className="d-flex justify-content-between align-items-center mt-3 w-100">
                            <span className="py-1 mx-1 type-register">
                              ชื่อผู้ขอกู้ยืม
                            </span>
                            <span className="mx-2 input-color border border-1 rounded-pill px-5 py-1 w-75 text-center">
                              {data[0]?.borrowName
                                ? data[0]?.borrowName
                                : "-"}
                            </span>
                          </div>
                          <div className="d-flex justify-content-between align-items-center mt-3 w-100">
                            <span className="py-1 mx-1 type-register">
                              ชื่อหลักสูตร
                            </span>
                            <span className="mx-2 input-color border border-1 rounded-pill px-5 py-1 w-75 text-center">
                              {data[0]?.traincourseName
                                ? data[0]?.traincourseName
                                : "-"}
                            </span>
                          </div>
                          <div className="d-flex justify-content-between align-items-center mt-3 w-100">
                            <span className="py-1 mx-1 type-register">
                              รุ่นที่
                            </span>
                            <span className="mx-2 input-color border border-1 rounded-pill px-5 py-1 w-75 text-center">
                              {data[0]?.class
                                ? data[0]?.class
                                : "-"}
                            </span>
                          </div>
                        </div>
                      </div>


                    </>
                  ) : (null)}

                  {testdata[0]?.testNewClassId != null ? (
                    <>
                      <div className="d-flex flex-column">
                        <div className="px-5 mt-5 d-flex flex-column">
                          <div className="d-flex justify-content-between align-items-center w-100">
                            <span className="py-1 mx-1 type-register">
                              เลขที่สัญญา
                            </span>
                            <span className="mx-2 input-color border border-1 rounded-pill px-5 py-1 w-75 text-center">
                              {testdata[0]?.contactNo
                                ? testdata[0]?.contactNo
                                : "-"}
                            </span>
                          </div>
                          <div className="d-flex justify-content-between align-items-center mt-3 w-100">
                            <span className="py-1 mx-1 type-register">
                              ชื่อผู้ขอกู้ยืม
                            </span>
                            <span className="mx-2 input-color border border-1 rounded-pill px-5 py-1 w-75 text-center">
                              {testdata[0]?.borrowName
                                ? testdata[0]?.borrowName
                                : "-"}
                            </span>
                          </div>

                          <div className="d-flex justify-content-between align-items-center mt-3 w-100">
                            <span className="py-1 mx-1 type-register">
                              ครั้งที่
                            </span>
                            <span className="mx-2 input-color border border-1 rounded-pill px-5 py-1 w-75 text-center">
                              {testdata[0]?.time
                                ? testdata[0]?.time
                                : "-"}
                            </span>
                          </div>
                        </div>
                      </div>


                    </>
                  ) : (null)}


                  <div className="text-center">
                    <button
                      className="btn-blue rounded-pill w-75 my-5"
                      onClick={() => {
                        navigate(`/borrowing/ExtendBorrowDetail?req=${searchParams.get("req")}&trainTestId=${trainTestId}`);
                      }}
                    >
                      ดูรายละเอียดคำขอเลื่อนวันที่การฝึกอบรมหรือทดสอบ
                      <FaSistrix className="mx-2 style-icon" />
                    </button>
                  </div>


                  <div className="w-100 p-3 mt-5 d-flex align-items-center justify-content-evenly">
                    <button type="submit" className="btn-green w-25">
                      อนุมัติ
                    </button>

                    <button
                      type="button"
                      onClick={modalToggleExtendCourse}
                      className="btn-red w-25"
                    >
                      ไม่อนุมัติ
                    </button>

                    <Formik
                      initialValues={formRejectInitialValues}
                      validationSchema={validateRejectSchema}
                      onSubmit={RejectSubmit}
                      enableReinitialize
                    >
                      {({
                        values,
                        handleChange,
                        handleBlur,
                        setFieldValue,
                        setValues,
                        errors,
                        touched,
                        resetForm,
                      }) => {
                        return (
                          <Modal
                            isOpen={openModalForm}
                            toggle={modalToggleExtendCourse}
                            style={{ maxWidth: "600px", width: "100%" }}
                            centered
                            className="modal-bordered"
                          >
                            <ModalBody>
                              <div className="d-flex flex-column">
                                <Form autoComplete="off">
                                  <Field
                                    name={`RemarkOfficer`}
                                    type="text"
                                    style={{ display: "none" }}
                                    disabled={true}
                                  ></Field>
                                  <FormGroup>
                                    <div className="mt-3">
                                      <span>กรุณากรอกความคิดเห็น</span>
                                      <Field name={`RemarkOfficer`}>
                                        {({ field, meta }) => (
                                          <Input
                                            className={
                                              meta.error && meta.touched
                                                ? "input-error rounded-pill text-center input-color"
                                                : "rounded-pill text-center input-color"
                                            }
                                            {...field}
                                          />
                                        )}
                                      </Field>
                                    </div>

                                    <div className="mt-4 d-flex align-items-center justify-content-between w-100">
                                      <button
                                        type="submit"
                                        className="btn-green w-25"
                                      >
                                        บันทึก
                                      </button>
                                      <button
                                        type="button"
                                        onClick={modalToggleExtendCourse}
                                        className="btn-red w-25 "
                                      >
                                        ยกเลิก
                                      </button>

                                    </div>
                                  </FormGroup>

                                </Form>

                              </div>
                            </ModalBody>
                          </Modal>
                        );
                      }}
                    </Formik>
                  </div>

                  <div className="d-flex align-items-center justify-content-center w-100 mt-3 mb-3">
                    <button onClick={() => {
                      navigate(
                        `/borrowing/`
                      );
                    }} className="btn-blue p-2 w-50">ย้อนกลับ</button>
                  </div>
                </div>
              </Container>
            </Form>
          </>
        );
      }}
    </Formik>
  );
}
